import React from 'react';
import styles from './close-button.module.scss';

interface CloseButtonProps {
	onClick: (event: React.MouseEvent) => void
}

export default function CloseButton({onClick}:CloseButtonProps) {
	return <button className={styles.default} onClick={onClick}/>
}